import type { TPageTranslations } from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import type { TKeys } from './types';

export const en: TPageTranslations<TKeys, typeof PAGE_KEY> = {
  [PAGE_KEY]: {
    SEO_TITLE: 'My requests | Attendance | Crehana',
    SEO_DESCRIPTION:
      'Request overtime work or compensatory time from your attendance administrator or supervisor.',

    PAGE_TITLE: 'My requests',
    PAGE_DESCRIPTION:
      'Request overtime work or compensatory time from your attendance administrator or supervisor.',
    BREADCRUMB_ATTENDANCE: 'Attendance',
    BREADCRUMB_MY_REQUESTS: 'My requests',
    BUTTON_CREATE_REQUEST: 'Create request',

    TABLE_HEADER_DATE: 'Date',
    TABLE_HEADER_SHIFT: 'Shift',
    TABLE_HEADER_OVERTIME: 'Overtime',
    TABLE_HEADER_COMPENSATION: 'Compensation time',
    TABLE_HEADER_REASON: 'Reason',
    TABLE_HEADER_STATUS: 'Status',
    TABLE_HEADER_ACTIONS: 'Actions',

    STATUS_PENDING: 'Pending',
    STATUS_APPROVED: 'Approved',
    STATUS_DENIED: 'Denied',
    STATUS_UPDATED_TOOLTIP:
      'The final time may differ from what was requested, since it reflects the time actually recorded during the workday and any adjustments made by the admin.',

    ACTION_CANCEL: 'Cancel request',
    ACTION_CANCEL_DISABLED_TOOLTIP:
      "This action isn't available for approved requests.",

    EMPTY_STATE_TITLE: 'No requests created yet',
    EMPTY_STATE_DESCRIPTION: "Once you do, they'll show up here.",
    TABLE_ERROR_TITLE: 'Something went wrong',
    TABLE_ERROR_DESCRIPTION: 'Click the button to try loading again.',
    ERROR_STATE_RETRY: 'Retry',

    CREATE_DIALOG_TITLE: 'Create request',
    CREATE_DIALOG_OPEN_DAY_WARNING:
      'The requested amount may be adjusted based on the time actually recorded in attendance for that day; if the recorded time is less than requested, only the recorded time will be paid out.',
    CREATE_DIALOG_DATE_LABEL: 'Date',
    CREATE_DIALOG_DATE_PLACEHOLDER: 'Select a date',
    CREATE_DIALOG_SHIFT_LABEL: 'Shift',
    CREATE_DIALOG_SHIFT_PLACEHOLDER: 'Select which shift this applies to',
    CREATE_DIALOG_SHIFT_NONE_PLACEHOLDER: 'This day has no assigned shift',
    CREATE_DIALOG_SHIFT_NONE_TOOLTIP:
      'You have no shifts assigned for this date',
    CREATE_DIALOG_SHIFT_ONE_TOOLTIP:
      'You only have one shift assigned for this date',
    CREATE_DIALOG_OVERTIME_LABEL: 'Overtime',
    CREATE_DIALOG_COMPENSATION_LABEL: 'Compensation time',
    CREATE_DIALOG_AMOUNT_PLACEHOLDER: 'HH:MM',
    CREATE_DIALOG_ROUNDING_PREVIEW:
      'This will be recorded as {{value}} according to the active rounding rule.',
    CREATE_DIALOG_REASON_LABEL: 'Reason',
    CREATE_DIALOG_REASON_PLACEHOLDER: 'Tell us the reason for your request',
    CREATE_DIALOG_CANCEL: 'Cancel',
    CREATE_DIALOG_SUBMIT: 'Save',

    VALIDATION_REQUIRED: 'Required field.',
    VALIDATION_DATE_REQUIRED: 'Required field.',
    VALIDATION_REASON_REQUIRED: 'Required field.',
    VALIDATION_REASON_MAX_LENGTH: 'The reason cannot exceed 250 characters.',
    VALIDATION_AMOUNT_FORMAT: 'Enter a valid amount of time.',
    VALIDATION_AMOUNTS_EXCEED_DAY:
      'The sum of overtime and compensation time cannot exceed 24 hours.',
    VALIDATION_DUPLICATE_REQUEST:
      'There is already a request or approved overtime/compensation time for this date.',
    VALIDATION_SHIFT_REQUIRED: 'Required field.',
    VALIDATION_SHIFT_NOT_RESOLVED:
      'This day has more than one shift. Try again and choose the right shift.',

    DELETE_ALERT_TITLE: 'Cancel request',
    DELETE_ALERT_DESCRIPTION:
      'Do you want to cancel your request for {{date}}? It will no longer be visible in the list, either to you or to your admin.',
    DELETE_ALERT_CONFIRM: 'Cancel request',
    DELETE_ALERT_CANCEL: 'Go back',

    TOAST_CREATE_SUCCESS: 'Your request was created.',
    TOAST_DELETE_SUCCESS: 'Your request was canceled.',
    TOAST_ERROR_GENERIC: 'We could not process your request. Please try again.',

    REQUESTS_ACTION_VIEW_DETAIL: 'View detail',

    REQUEST_DETAIL_DRAWER_TITLE: 'Request for {{date}}',
    REQUEST_DETAIL_CREATED_AT_LABEL: 'Request date',
    REQUEST_DETAIL_REASON_LABEL: 'Reason',
    REQUEST_DETAIL_OVERTIME_REQUESTED_LABEL: 'Overtime requested',
    REQUEST_DETAIL_COMPENSATION_REQUESTED_LABEL: 'Compensation time requested',
    REQUEST_DETAIL_OVERTIME_FINAL_LABEL: 'Overtime approved',
    REQUEST_DETAIL_COMPENSATION_FINAL_LABEL: 'Compensation time approved',
    REQUEST_DETAIL_RESPONDED_BY_LABEL: 'Responded by',
    REQUEST_DETAIL_COMMENTS_THREAD_TITLE: 'Thread',
    REQUEST_DETAIL_COMMENTS_EMPTY: 'Not available yet',
    REQUEST_DETAIL_COMMENTS_EMPTY_SUBTITLE:
      'Comments your admin leaves on this request will show up here.',
    REQUEST_DETAIL_COMMENT_LABEL: 'Add a comment',
    REQUEST_DETAIL_COMMENT_PLACEHOLDER:
      'Use this space to add comments about this request.',
    REQUEST_DETAIL_COMMENT_SUBMIT: 'Add comment',
    VALIDATION_COMMENT_MAX_LENGTH: 'The comment cannot exceed 150 characters.',
  },
};
